import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, ToastController } from 'ionic-angular';
import { Configuration } from '../../constants/config';
import { InventarioServiceProvider } from '../../providers/inventario-service/inventario-service';
import { CategoryServiceProvider } from '../../providers/category-service/category-service';

/**
 * Generated class for the InventoryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-inventory',
    templateUrl: 'inventory.html',
})
export class InventoryPage {

    itemList = [];
    itemListAll = [];
    categoryList = [];

    constructor(public navCtrl: NavController, public navParams: NavParams, public modalCtrl: ModalController, public toastCtrl: ToastController, public inventarioService: InventarioServiceProvider, public categoryService: CategoryServiceProvider, public _configuration: Configuration) {
        this.load();
    }

    /**
     * @Info Load item list
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    load(){
        let data = {IdItem: 0, UPC: "0", token: this._configuration.token};
        this.inventarioService.getList(data)
            .then(data => {
                let response : any = data;
                if (!response.Error){
                    this.itemList = response.Content;
                    this.itemListAll = response.Content;
                    this.getCategoryList();
                }else{
                    let toast = this.toastCtrl.create({message: response.ErrorMessage,position: 'middle',duration: 3000});
                    toast.present();
                }
            });
    }


    /**
     * @Info Get category List
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    getCategoryList(){
        let data = {IdCategory: 0, token: this._configuration.token};
        this.categoryService.getList(data)
            .then(data => {
                let response : any = data;
                if (!response.Error){
                    this.categoryList = response.Content;
                }else{
                    let toast = this.toastCtrl.create({message: response.ErrorMessage,position: 'middle',duration: 3000});
                    toast.present();
                }
            });
    }



    /**
     * @Info Create item
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    createItem(){
        const modalData = {isEdit: false, categoryList: this.categoryList};
        let modal = this.modalCtrl.create("ModalItemPage", { data: modalData });
        modal.onDidDismiss(data => {
            if (data){
                if (data.reaload){
                    this.load();
                }
            }
        });
        modal.present();
    }

    /**
     * @Info Edit item
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    editItem(item){
        const modalData = {isEdit: true, categoryList: this.categoryList, item: item};
        const modal = this.modalCtrl.create("ModalItemPage", {data: modalData});
        modal.onDidDismiss(data => {
            if (data){
                if (data.reaload){
                    let toast = this.toastCtrl.create({message: "Successfully applied changes",position: 'middle',duration: 3000});
                    toast.present();
                    this.load();
                }
            }
        });
        modal.present();
    }


    /**
     * @Info Add Quantity to item
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-22
     */
    addQantity(item){
        const modalData = {item: item};
        const modal = this.modalCtrl.create("ModalItemAddPage", {data: modalData});
        modal.onDidDismiss(data => {
            if (data){
                if (data.reaload){
                    this.load();
                }
            }
        });
        modal.present();
    }


    /**
     * @Info Show all items
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-28
     */
    showAll(ev: any) {
        this.itemList = this.itemListAll;
    }


    /**
     * @Info Search items
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-28
     */
    getItems(ev: any) {
        // set val to the value of the searchbar
        let val = ev.target.value;

        // if the value is an empty string don't filter the items
        if (val && val.trim() != '') {
            this.itemList = this.itemList.filter((item) => {
                return (item.Name.toLowerCase().indexOf(val.toLowerCase()) > -1);
            })
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/inventory/inventory.ts